import { useTranslation } from 'next-i18next'
import parse from 'html-react-parser'
import { CustomTypeOptions } from 'react-i18next'

import { unOrphan } from '@/utils/orphans'

import {
  Container,
  GridSeo,
  Line,
  Text,
  StyledH2
} from './SeoDescription.styled'

interface Props {
  name: keyof CustomTypeOptions['resources']['parkings']['seoDescription']
  heading?: string
}

function SeoDescription({ name, heading }: Props) {
  const { t } = useTranslation('parkings')
  const rawContent = t(`seoDescription.${name}`)
  const seoContent = unOrphan(rawContent)
  const paragraphs = seoContent.split('\n\n')

  return (
    <Container role="region" aria-label="Parking Description">
      <GridSeo as="article">
        <Line />
        {heading && <StyledH2>{heading}</StyledH2>}
        {paragraphs.map((paragraph, idx) => (
          <Text as="div" key={idx}>
            {parse(paragraph)}
          </Text>
        ))}
        <Line />
      </GridSeo>
    </Container>
  )
}

export default SeoDescription
